<template>
  <div :class="mhClass + ' ' + (isEmail ? 'blue' : '')" :key="render">
    <b-form-group
      v-if="fixed"
      :label="label"
      label-size="sm"
      label-class="mb-0"
      label-for="fixed"
    >
      <b-input-group size="sm">
        <b-input-group-prepend :is-text="!prependTo" v-if="prepend !== null">
          <b-button v-if="prependTo" :to="prependTo">{{ prepend }}</b-button>
          <span v-else>{{ prepend }}</span>
        </b-input-group-prepend>
        <b-form-input
          size="sm"
          :required="required"
          :class="inputClass"
          :readonly="readonly"
          v-model="value"
          :autofocus="autofocus"
        >
        </b-form-input>
        <b-input-group-append is-text v-if="append !== null">{{
          append
        }}</b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group
      v-else
      class="my-1"
      :label="nolabel ? null : label ? label : table[field].label"
      :label-cols-lg="label || table[field].label ? labelColsLg : 0"
      :content-cols-lg="contentColsLg"
      label-size="sm"
      label-class="mb-0"
      :label-for="field"
      :description="info"
    >
      <b-input-group size="sm" v-if="table[field].options == null">
        <b-input-group-prepend :is-text="!prependTo" v-if="prepend !== null">
          <b-button v-if="prependTo" :to="prependTo">{{ prepend }}</b-button>
          <span v-else>{{ prepend }}</span>
        </b-input-group-prepend>
        <template v-if="table[field].type == 'date'">
          <b-form-input
            v-model="table[field].value"
            type="text"
            :readonly="readonly"
            placeholder="YYYY-MM-DD"
            onClick="this.select();"
            autocomplete="off"
            :autofocus="autofocus"
            @change="$emit('change')"
          >
          </b-form-input>
          <b-input-group-append>
            <b-datepicker
              :name="field"
              :readonly="readonly"
              button-only
              no-flip
              right
              locale="fr-BE"
              :start-weekday="1"
              v-model="table[field].value"
              :required="required"
              label-no-date-selected="--"
              @input="$emit('change')"
            >
            </b-datepicker>
          </b-input-group-append>
        </template>

        <b-form-textarea
          v-else-if="
            table[field].type == 'text' || table[field].type == 'longtext'
          "
          size="sm"
          :rows="rows"
          :id="field"
          :name="field"
          :readonly="readonly"
          :required="required"
          :autofocus="autofocus"
          v-model="table[field].value"
          @change="$emit('change')"
        ></b-form-textarea>
        <vue-editor
          ref="editor"
          style="width: 100%; max-height: 400px; margin-bottom: 55px"
          v-else-if="table[field].type == 'html'"
          v-model="table[field].value"
          :editor-toolbar="customToolbar"
          :editorOptions="editorSettings"
          :id="field"
          :disabled="readonly"
        >
        </vue-editor>
        <b-form-input
          v-else
          size="sm"
          :class="{
            'text-right':
              table[field].type == 'float' ||
              table[field].type == 'double' ||
              table[field].type == 'decimal',
          }"
          :type="type == 'IBAN' ? 'text' : type"
          :min="min"
          :max="max"
          :id="field"
          :name="field"
          :readonly="readonly"
          :state="
            table[field].error || state == false
              ? false
              : state == true
              ? true
              : null
          "
          v-model="table[field].value"
          :autocomplete="autocomplete.field === null ? 'on' : 'off'"
          :debounce="debounce"
          :required="required"
          :autofocus="autofocus"
          :pattern="table[field].pattern"
          @change="$emit('change')"
          @update="update"
          @keyup="keyup"
        ></b-form-input>

        <div :id="'ac' + _uid" class="autocomplete">
          <div v-if="ac.length > 0">
            <b-list-group class="shadow">
              <b-list-group-item
                v-for="(item, index) in ac"
                :key="index"
                :active="index == activeAc"
                :data="index"
                :variant="item.history ? 'info' : ''"
              >
                <span v-if="item.icon" class="pr-2">
                  <b-icon :icon="item.icon"></b-icon>
                </span>
                <span v-html="item.highlighted"></span>
                <span v-if="item.history">
                  <b-icon-clock-history
                    class="float-right"
                  ></b-icon-clock-history>
                </span>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>

        <b-input-group-append :is-text="!appendTo" v-if="append !== null">
          <b-button v-if="appendTo" :to="appendTo">{{ append }}</b-button>
          <span v-else>{{ append }}</span>
        </b-input-group-append>
        <b-input-group-append v-if="isEmail">
          <b-button variant="primary" :href="'mailto:' + table[field].value"
            ><b-icon icon="envelope"></b-icon
          ></b-button>
        </b-input-group-append>
        <b-input-group-append v-if="isMobileNumber">
          <b-button @click="modalSms = !modalSms" variant="primary"
            ><span v-if="sms_sending"
              ><b-icon icon="arrow-clockwise" animation="spin"></b-icon></span
            ><span v-else>SMS</span></b-button
          >
          <b-modal @ok="sendSMS" v-model="modalSms" title="Envoi d'un SMS">
            <p class="my-4">Encodez votre SMS!</p>
            <b-form-textarea required v-model="sms_content"></b-form-textarea>
          </b-modal>
        </b-input-group-append>
      </b-input-group>
      <b-form-select
        v-else-if="select_type == 'several'"
        size="sm"
        :id="field"
        :name="field"
        v-model="table[field].value"
        :disabled="readonly"
        :options="table[field].options"
        :required="required"
        @change="$emit('change')"
      ></b-form-select>
      <template v-else>
        <b-form-checkbox
          switch
          :disabled="readonly"
          v-model="table[field].value"
          :name="field"
          :value="table[field].options[0].value"
          :unchecked-value="table[field].options[1].value"
          @input="$emit('change')"
        >
        </b-form-checkbox>
      </template>

      <b-form-text v-if="table[field].error">
        {{ table[field].error }}
      </b-form-text>
    </b-form-group>
    <slot></slot>
  </div>
</template>

<script>
import axios from "axios";
import autocomplete from "@/services/autocomplete.js";
import sms from "@/services/sms.js";
import { VueEditor, Quill } from "vue2-editor";
import Clipboard from "quill/modules/clipboard.js";
Quill.register("modules/clipboard", Clipboard);
export default {
  name: "mh-input",
  components: {
    VueEditor,
  },
  props: {
    name: String,
    labelColsLg: {
      type: [Number, String, Boolean],
      default: 4,
    },
    contentColsLg: {
      type: [Number, String, Boolean],
      default: true,
    },
    info: {
      type: String,
      default: "",
    },
    mhClass: {
      type: String,
      default: "",
    },
    standalone: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isMobileNumber: {
      type: Boolean,
      default: false,
    },
    debounce: {
      type: [Number, String],
      default: 200,
    },
    field: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    table: Object,
    appendTo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    append: {
      type: String,
      default: null,
    },
    prependTo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    prepend: {
      type: String,
      default: null,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    inputClass: String,
    nolabel: {
      type: Boolean,
      default: false,
    },
    label: String,
    value: [String, Number],
    rows: {
      type: [String, Number],
      default: 1,
    },
    state: {
      type: Boolean,
      default: null,
    },
    min: null,
    max: null,
    type: {
      type: String,
      default: "text",
    },
    autocomplete: {
      type: Object,
      default: () => {
        return { field: null, api: null };
      },
    },
  },

  watch: {
    error: {
      immediate: true,
      handler() {
        this.render++;
      },
    },
  },
  data() {
    return {
      ac: [],
      apiInstance: null,
      activeAc: -1,
      render: 0,
      cancelToken: null,
      cancel: undefined,
      modalSms: false,
      sms_content: "",
      sms_sending: false,
      select_type: "several",
      editorSettings: {
        modules: {
          clipboard: {
            matchVisual: false,
          },
        },
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["image", "code-block"],
      ],
    };
  },
  created() {
    this.apiInstance = axios.create({
      baseURL: this.autocomplete.api || this.$store.getters.url + "",
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
    });
    let token = localStorage.getItem("vue-token");
    if (token) {
      this.apiInstance.defaults.headers.common["Authorization"] =
        "Bearer " + token;
    }
    this.cancelToken = axios.CancelToken;
    if (
      this.table &&
      this.table[this.field].type == "date" &&
      this.table[this.field].value == "0000-00-00"
    ) {
      this.table[this.field].value = null;
    }
    if (
      this.table[this.field].type == "enum" &&
      this.table[this.field].options.length == 2
    ) {
      let boolean_values = ["yes", "oui", "1", "non", "no", "0", "on", "off"];
      let n = 0;
      this.table[this.field].options.forEach((el) => {
        if (boolean_values.includes(el.value)) {
          n++;
        }
      });
      if (n == 2) {
        this.select_type = "checkbox";
        this.noLabel = true;
      }
    }
  },
  mounted() {
    const el = document.querySelector("#ac" + this._uid);
    if (el == null) {
      return;
    }
    document.addEventListener(
      "click",
      (e) => {
        if (el.contains(e.target)) {
          const id = e.target.closest(".list-group-item").getAttribute("data");
          this.table[this.field].value = this.ac[id].value;
          this.$emit("enter", this.ac[id].data || this.table[this.field].value);
          if (this.autocomplete.to && this.ac[id].id) {
            this.autocomplete.to.params = { id: this.ac[id].id };
            this.$router.push(this.autocomplete.to);
          }
          this.ac = [];
          this.activeAc = -1;
          e.preventDefault();
          document.getElementById(this.field).focus();
          this.enter();
        } else {
          this.blur();
        }
      },
      true
    );
    if (this.autofocus && this.$refs.editor) {
      this.$refs.editor.quill.focus();
    }
  },
  computed: {
    isEmail() {
      //
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-console
      let exploded = String(this.table[this.field].value).split(/[\s,;]+/);
      let result = true;
      exploded.forEach(el => {
        if(! (re.test(el.toLowerCase().trim()))) {
          result = false;
        }
      })
      return result;
      
    },
    error() {
      return this.table ? this.table[this.field].error : false;
    },
  },
  methods: {
    sendSMS() {
      let value = this.table[this.field].value;
      let numberFormatted = value.replaceAll(/[^\d+]/g, "");
      if (numberFormatted.indexOf("0") == 0) {
        numberFormatted = "+32" + numberFormatted.substr(1);
      }
      this.sms_sending = true;
      sms
        .send(numberFormatted, this.sms_content)

        .then((response) => {
          if (response.data.status == "success") {
            this.$bvToast.toast("SMS envoyé", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
          }
          this.sms_sending = false;
        })
        .catch(() => {
          this.sms_sending = false;
        });
    },
    blur() {
      this.ac = [];
      this.activeAc = -1;
    },
    enter() {
      if (this.cancel) {
        this.cancel.call();
      }
      if (this.table.search) {
        this.table.search.value = "";
      }
    },
    update() {
      if (this.$props.type == "IBAN") {
        let iban = this.table[this.field].value;
        const regex = /[^A-Za-z0-9]/gm;
        iban = iban.replace(regex, "").toUpperCase();
        var chunks = [];
        for (var i = 0, charsLength = iban.length; i < charsLength; i += 4) {
          chunks.push(iban.substring(i, i + 4));
        }
        iban = chunks.join(" ");
        this.table[this.field].value = iban;
      }
      if (this.autocomplete.field) {
        this.autocomplete.value = this.table[this.field].value;
        if (this.cancel !== undefined) {
          this.cancel.call();
        }
        let that = this;
        autocomplete
          .get(this.autocomplete, {
            cancelToken: new this.cancelToken(function executor(c) {
              that.cancel = c;
            }),
          })
          .then((response) => {
            this.ac = response.data;
            //this.searchHistory(this.autocomplete.value);
            if (this.activeAc >= this.ac.length) {
              this.activeAc = 0;
            }
          })
          .catch(() => {});
      }
      this.$emit("update");
    },
    keyup(e) {
      
      if (e.key == "Enter") {
        if (
          this.autocomplete.field &&
          this.ac.length > 0 &&
          this.ac[this.activeAc]
        ) {
          if (this.autocomplete.to && this.ac[this.activeAc].id) {
            this.autocomplete.to.params = { id: this.ac[this.activeAc].id };
            this.$router.push(this.autocomplete.to);
          }
          this.$emit("enter", this.ac[this.activeAc].value);
        } else {
          this.$emit("enter", this.table[this.field].value);
        }
        this.blur();
        this.enter();
        return;
      }

      if (this.autocomplete.field) {
        if (this.ac.length > 0) {
          switch (e.key) {
            case "ArrowDown":
              this.activeAc++;
              if (this.activeAc >= this.ac.length) {
                this.activeAc = 0;
              }
              this.table[this.field].value =
                this.ac[this.activeAc].value.trim();
              break;
            case "ArrowUp":
              this.activeAc--;
              if (this.activeAc < 0) {
                this.activeAc = this.ac.length - 1;
              }
              this.table[this.field].value =
                this.ac[this.activeAc].value.trim();
              break;
            case "Enter":
              this.table[this.field].value =
                this.ac[this.activeAc].value.trim();
              this.ac = [];
              break;
            case "Tab":
            case "Escape":
              this.ac = [];
              break;
            case "ArrowLeft":
            case "ArrowRight":
              break;
          }
        }
      }
    },

    searchHistory(str) {
      if (str == undefined || str.trim() == "") return;
      let history = JSON.parse(
        localStorage.getItem("history_" + this.autocomplete.idHistory)
      );
      if (history !== null) {
        for (let i = 0; i < history.length; i++) {
          if (history[i][0].toLowerCase().indexOf(str.toLowerCase()) !== -1) {
            this.ac.unshift({
              value: history[i][0],
              highlighted: history[i][0],
              history: true,
            });
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
.b-form-btn-label-control.dropdown.b-form-datepicker.btn-group
  .dropdown-toggle {
  height: 1.9rem !important;
  padding-top: 2px;
}
.blue {
  input {
    color: var(--cyan);
  }
  a.btn {
    color: var(--cyan) !important;
  }
}
.was-validated .form-control:invalid,
.form-control.is-invalid {
  border-color: #dc3545;
  background-image: none !important;
}
label {
  font-style: italic;
}
.input-group {
  background-color: #f7f7f7 !important;
  box-shadow: none;

  transition: box-shadow 0.3s ease-in-out !important;
  &:hover {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3) !important;
  }
}
</style>
<style lang="scss" scoped>
.list-group-item {
  border-bottom: none;
  padding: 5px 10px;
  font-size: 14px;
  &.active {
    background-color: DodgerBlue;
  }
  &:hover {
    background-color: #ff9933;
    cursor: pointer;
  }
}
.autocomplete {
  z-index: 100;
  position: absolute;
  top: 30px;
  padding-left: 0 !important;
  margin: 0;
  background-color: #e9e9e9;
  display: inline-block;
  ul {
    list-style-type: none;
  }
}
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
}
.autocomplete-items div {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #d4d4d4;
}
.autocomplete-items div:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}
.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}
</style>